import * as API from './api'
import * as Types from './Types'

export function tryCreateBookingSystem(token, data, communityId) {
  return dispatch => {
    dispatch({
      type: Types.CREATE_BOOKING_SYSTEM
    })

    API.createBookingSystem(token, data)
      .then(response => {
        dispatch({
          type: Types.CREATE_BOOKING_SYSTEM_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(error => {
        dispatch({
          type: Types.CREATE_BOOKING_SYSTEM_FAILED,
          payload: 500
        })
      })
  }
}

export function tryDeleteBookingSystem(token, bookableId) {
  return dispatch => {
    dispatch({
      type: Types.DELETE_BOOKING_SYSTEM,
      payload: bookableId
    })

    API.deleteBookingSystem(token, bookableId)
      .then(() => {
        dispatch({
          type: Types.DELETE_BOOKING_SYSTEM_SUCCESS,
          payload: bookableId
        })
      })
      .catch(error => {
        dispatch({
          type: Types.DELETE_BOOKING_SYSTEM_FAILED,
          payload: { status: 500, bookableId }
        })
      })
  }
}

export function tryUpdateBookingSystem(token, bookableId, data) {
  return dispatch => {
    dispatch({
      type: Types.UPDATE_BOOKING_SYSTEM,
      payload: bookableId
    })

    API.updateBookingSystem(token, bookableId, data)
      .then(response => {
        dispatch({
          type: Types.UPDATE_BOOKING_SYSTEM_SUCCESS,
          payload: { data: response.data.data, bookableId }
        })
      })
      .catch(error => {
        dispatch({
          type: Types.UPDATE_BOOKING_SYSTEM_FAILED,
          payload: { status: 500, bookableId }
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/actions/BookingSystems.js